var map = {
	"./1People.png": 299,
	"./Artelize.png": 3878,
	"./Concordium.png": 5580,
	"./DoLand.png": 347,
	"./FairBusinessGrowth.png": 8178,
	"./FairMedia.png": 6625,
	"./FairShop.png": 9709,
	"./LoveNature.png": 1538,
	"./Valified.png": 1321,
	"./WL.png": 7114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5379;